import { render, staticRenderFns } from "./RecruitmentInfo.vue?vue&type=template&id=cce0442c&scoped=true"
import script from "./RecruitmentInfo.vue?vue&type=script&lang=js"
export * from "./RecruitmentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce0442c",
  null
  
)

export default component.exports